import React, { Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { Route, withRouter } from "react-router-dom";
import ResizeDetector from "react-resize-detector";
import AppMain from "../../Layout/AppMain";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppHeader from "../../Layout/AppHeader";
import VerticalNavWrapper from "../../Layout/AppNav/VerticalNavWrapper";
import ReportForm from "../Form/ReportForm/index";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: false,
      isSidebarOpen: true
    };
  }

  toggleSidebar = () => {
    this.setState(prev => ({ isSidebarOpen: !prev.isSidebarOpen }));
  };

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
      location
    } = this.props;

    const { isSidebarOpen } = this.state;

    // Check if user is authenticated
    const isAuthenticated = sessionStorage.getItem("adminId");
    // Don't render sidebar/header structure for login page
    if (location.pathname === '/login') {
      return (
        <Fragment>
          <AppMain isSidebarOpen={isSidebarOpen} />
          <ToastContainer
            position="top-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Fragment>
      );
    }

    if (location.pathname === '/reportform') {
      return (
        <Fragment>
          <ReportForm />
          <ToastContainer
            position="top-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Fragment>
      );
    }

    return (
      <Fragment>
        {/* Render Sidebar and Header only if authenticated */}
        {isAuthenticated && (
          <VerticalNavWrapper 
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={this.toggleSidebar}
          />
        )}
        
        <div
          className={cx(
            "app-container app-theme-" + colorScheme,
            { "fixed-header": enableFixedHeader },
            { "fixed-sidebar": enableFixedSidebar },
            { "fixed-footer": enableFixedFooter },
            { "closed-sidebar": enableClosedSidebar },
            { "closed-sidebar-mobile": closedSmallerSidebar },
            { "sidebar-mobile-open": enableMobileMenu },
            { "body-tabs-shadow-btn": enablePageTabsAlt }
          )}
          style={{
            marginLeft: isAuthenticated ? (isSidebarOpen ? "260px" : "80px") : "0",
            transition: "margin-left 0.4s ease",
            position: "relative",
            zIndex: 1
          }}
        >
          {/* Render AppHeader only if authenticated */}
          {isAuthenticated && <AppHeader />}
          <AppMain isSidebarOpen={isSidebarOpen} />

          <ToastContainer
            position="top-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            zIndex={9999}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

export default withRouter(connect(mapStateToProp)(Main));